module.exports = __webpack_public_path__ + "static/PHP_Wordpress-a64f36bc4f064503a70b2b8c23ca7c61.mp4";